const mapperMainProjectToForm = form => {
    let mainProject = form.main_projects.map(response => {
        return {
            id: response.id,
            name: response.name,
            description: response.description,
        }
    })

    return {
        mainProject,
    }
}

export { mapperMainProjectToForm }
